<p-confirmDialog key="stationblockalertassignment" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="stationblockalertassignmentconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div *ngIf="SelectedStationBlockAlert == undefined || SelectedStationBlockAlert == null || SelectedStationBlockAlert.StationBlockAlertID == undefined">
	<h4 style="text-align: center; margin-top: 45px">- Select a Block List to view assigned groups, homerooms, students, etc. -</h4>
</div>

<div *ngIf="SelectedStationBlockAlert != undefined && SelectedStationBlockAlert != null && SelectedStationBlockAlert.StationBlockAlertID != undefined">
	<!--Menu Bar-->
	<div class="lock-to-top" style="background-color: #ffffff">
		<!--Buttons-->
		<div class="button-body flex">
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddGroup()">Add Groups</button>
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddHomeroom()">Add Homerooms</button>
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddStudent()">Add Students</button>
			<button [disabled]="IsLoading() == true" class="btn btn-warning" style="margin-left: 5px" (click)="onActivate()">Activate</button>
			<button [disabled]="IsLoading() == true" class="btn btn-warning" style="margin-left: 5px" (click)="onDeactivate()">Deactivate</button>
			<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete</button>
		</div>
	</div>

	<!--Table-->
	<div class="table-main-body">
		<p-table
			#mydt
			[value]="lstTable"
			[loading]="IsLoading() == true"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedItems"
			dataKey="TableID"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--INSERT CUSTOM FILTERS HERE-->
					<th></th>

					<!--TypeDesc-->
					<th>
						<p-columnFilter field="TypeDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterTypeDesc
									[ngModel]="value"
									[options]="lstTypeDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--AssignedDesc-->
					<th>
						<p-columnFilter type="text" field="AssignedDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--ActiveDesc-->
					<th>
						<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterActiveDesc
									[ngModel]="value"
									[options]="lstActiveDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th>
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>
					<th pSortableColumn="TypeDesc">Type<p-sortIcon field="TypeDesc"></p-sortIcon></th>
					<th pSortableColumn="AssignedDesc">Description<p-sortIcon field="AssignedDesc"></p-sortIcon></th>
					<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Item>
				<tr [pSelectableRow]="Item">
					<td>
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="Item" [value]="Item"></p-tableCheckbox>
					</td>
					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Item.TypeDesc }}
					</td>
					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Item.AssignedDesc }}
					</td>
					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Item.Active == true ? 'Black' : 'Red'">
						{{ Item.ActiveDesc }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--Error Message-->
	<div class="TopMargin">
		<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
	</div>
</div>
